import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import moment from 'moment';

import debounce from 'debounce';

import {
    Affix,
    Button,
    Card,
    Checkbox,
    Col,
    Icon,
    Input,
    message,
    Modal,
    InputNumber,

    Row,
    Alert,
    Divider,
    Spin,
    Select,
    Switch,
    Tag,
    Table,
    Tabs,
    Upload,
    Radio,
} from 'antd';

import EnterpriseOciPunchoutCredentials from "./enterprise-oci-punchout-credentials";
import EnterpriseUomMapping from "./enterprise-uom-mapping";

import {
    _getAllCategories,
    _getEnterpriseData,
    _getEnterpriseUsers,
    _postAddCcEmail,
    _postToggleEnterprisePermission,
    _postRemoveCcEmail,
    _postRemoveUserFromEnterprise,
    _postUpdateEnterprisePunchoutSettings,
    _postUpdateEnterpriseRestrictedBrandsSettings,
    _postUpdateEnterpriseRestrictedCategorySettings,
    _postUpdateEnterpriseCreditLimit,
    _postUpdateEnterpriseSettings,
    _postSetEnterpriseModuleTier,
    _postToggleModule,
    _postUpdateSalesAgent,
    _postUpdateSize,
    _postUpdateWallet,
    _putPaymentDetails,
    _putPlatformFee,
    _putAutoSendArInvoice,
    _putAutoSendPodCompletion,
    _putSendArInvoiceToFinanceEmailOnly,
    _putConsolidateArInvoice,
    _putBillingCutOffDates,
    _putConsolidateArInvoiceBySo,
    _putActivateConsolidateArInvoiceFlag,
    _putDeactivateConsolidateArInvoiceFlags,
    _putFinanceEmail,
    _putQuotationCcEmail
} from '../../services';

import { API_ENDPOINT } from '../../index';

import UserEmailInvite from './user-email-invite';
import EnterpriseAddOns from './add-ons';
import SalesAgentSelector from './sales-agent-select';
import EnterpriseCustomFields from './custom-fields';
import EezeePaymentDetails from './profile-eezee-payment-details';

import { getRandomKey } from "../../utils/index";

const { Option } = Select;

// ponytail: hardcoded allowlist, same as before — move to env/DB/roles only if it starts churning
const CAN_CHANGE_CREDIT_EMAILS = ["nicholas.tan@eezee.com.sg", "bobby.hartanto@eezee.com.sg", "joshua.liew@eezee.com.sg", "ken.lok@eezee.com.sg", "logan@eezee.com.sg", "dwifitri.laurenza@eezee.com.sg"];

class EnterpriseProfile extends React.Component {

    render() {

        const { enterprise, enterpriseUsers, page, limit, searchTerm, count, loading } = this.state;

        if (loading) {
            return <div>loading..</div>;
        }

        const columns = [

            {
                title: 'Name',
                dataIndex: 'details.name',
                key: 'name',
                render: (name, record) => {
                    return (
                        <Row type="flex" align="middle" justify="space-between">
                            <Col>
                                <span style={{
                                    marginRight: 8
                                }} >{name || ""}</span>
                            </Col>
                        </Row>
                    );
                }
            }, {
                title: 'Permissions',
                dataIndex: 'enterprise.permissions',
                key: 'permissions',
                render: (permissions, record) => {

                    const userId = record._id;

                    return (
                        <Row type="flex" style={{ width: 400 }} gutter={4}>
                            <Col>
                                {this.renderTag({ userId, key: 'superuser', color: permissions && permissions.superuser ? 'purple' : null })}
                            </Col>
                            <Col>
                                {this.renderTag({ userId, key: 'finance', color: permissions && permissions.finance ? 'gold' : null })}
                            </Col>
                            <Col>
                                {this.renderTag({
                                    userId, key: 'procurement', color: permissions && permissions.procurement
                                        ? 'cyan' : null
                                })}
                            </Col>
                        </Row>
                    );
                }
            },
            {
                title: 'Email',
                dataIndex: 'local',
                key: 'email',
                render: (local, record) => {
                    return (
                        <span>
                            {local && local.email}
                            {!record.verifiedEmail &&
                                <Tag style={{ marginLeft: 8 }} color="orange">Unverified</Tag>
                            }
                        </span>
                    );
                }
            },

            {
                title: 'Last Active',
                dataIndex: 'lastActive',
                key: 'lastActive',
                render: (lastActive, record) => {

                    if (lastActive) {
                        return moment(lastActive).format('ll');
                    }

                    return null;
                }
            },
            {
                title: 'Remove',
                dataIndex: '_id',
                key: 'remove',
                render: (userId) => {
                    return (
                        <a
                            onClick={() => this.handleRemove(userId)}
                        >Remove</a>
                    );
                }
            }
        ];

        const isProduction = process.env.REACT_APP_CUSTOM_NODE_ENV === 'production';

        return (
            <Card
                className="enterprise-profile-card"
                bodyStyle={{ padding: 0 }}
                title={(
                    <Row type="flex" justify="space-between">
                        <Col>{enterprise.companyName || "Loading..."}</Col>
                    </Row>
                )}

            >
                {!enterprise.tier && (
                    <Row>
                        <Alert
                            message="TIER NOT ASSIGNED"
                            description="Non-punchout enterprise will not work if a tier is not assigned."
                            type="error"
                            showIcon
                        />
                    </Row>
                )}

                <Tabs
                    onChange={this.handleOnChangeTab}
                    defaultActiveKey={this.props.pageKey || "tiers"}
                    animated={false}>
                    <Tabs.TabPane
                        key="tiers"
                        tab="Tiers"
                    >
                        {this.renderTiers()}
                        <EnterpriseAddOns
                            enterprise={this.state.enterprise}
                            setEnterprise={(enterprise) => this.setState({ enterprise })}
                            saveCheckoutThreshold={this.handleSaveCheckoutThreshold}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        key="users"
                        tab={<span>
                            Users
                        </span>
                        }
                    >
                        <Card
                            type="inner"
                            title={
                                <Row type="flex" justify="space-between" gutter={16}>
                                    <Col span={12}>
                                        <Input
                                            prefix={<Icon type="search" />}
                                            placeholder={"Search name or email"}
                                            onChange={this.handleOnChangeSearch}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <UserEmailInvite
                                            enterpriseId={enterprise._id}
                                            getEnterpriseUsers={this.getEnterpriseUsers}
                                        />
                                    </Col>
                                </Row>
                            }
                        >
                            <Table
                                columns={columns}
                                dataSource={enterpriseUsers}
                                pagination={{
                                    current: page,
                                    pageSize: limit,
                                    total: count,
                                    onChange: this.handlePageChange
                                }}
                            />
                        </Card>
                    </Tabs.TabPane>
                    <Tabs.TabPane
                        key="addresses"
                        tab="Addresses">

                        <div>

                            <Row style={{ marginBottom: 16 }} type="flex" gutter={8}>
                                <Col>
                                    <Button size="large"
                                        type="default"
                                        href={`${API_ENDPOINT}/api/admin/enterprise/addresses/${enterprise._id}`}>Download Address xlsx</Button>
                                </Col>
                                <Col>

                                    <Upload
                                        name="addresses"
                                        action={`${API_ENDPOINT}/api/admin/enterprise/addresses/${enterprise._id}`}
                                        onChange={this.handleOnChangeUploadStatus}
                                        showUploadList={false}
                                        withCredentials={true}>
                                        <Button size="large"
                                            type="primary">Upload Address xlsx</Button>
                                    </Upload>
                                </Col>
                            </Row>

                            <Table
                                pagination={false}
                                columns={[
                                    { title: "#", key: "index", render: (_text, _record, index) => index + 1 },
                                    { title: "addressId*", dataIndex: "addressId" }, // A1
                                    { title: "groupName*", dataIndex: "groupName" }, // A1
                                    { title: "companyName*", dataIndex: "companyName" }, // A1
                                    { title: "full address*", dataIndex: "fullAddress" }, // A2
                                    { title: "city*", dataIndex: "city" }, // A3
                                    { title: "isoCountryCode*", dataIndex: "isoCountryCode" }, // A4
                                    { title: "postalCode*", dataIndex: "postalCode" }, // A5
                                    { title: "billingOnly", dataIndex: "billingOnly", render: (text) => text ? "true" : "" }, // A6
                                    { title: "dayOfDelivery*", dataIndex: "dayOfDelivery" }, // A7
                                    { title: "deliveryBuffer*", dataIndex: "deliveryBuffer" }, // A8
                                    { title: "altDayOfDelivery", dataIndex: "altDayOfDelivery" }, //A9
                                    { title: "fulfillmentRemarks", dataIndex: "fulfillmentRemarks" } //A10
                                ]}
                                dataSource={enterprise.addresses}
                            />

                        </div>


                    </Tabs.TabPane>

                    {/* 
                        ---- PUNCHOUT TAB ----
                    */}
                    <Tabs.TabPane
                        key="punchout"
                        tab={
                            <span>
                                {
                                    enterprise.punchoutModule ?
                                        <Icon theme="twoTone" twoToneColor="#52c41a" type="check-circle" /> :
                                        <Icon theme="twoTone" twoToneColor="red" type="close-circle" />
                                }
                                <Icon type="done" />
                                Punchout
                            </span>
                        }
                    >
                        <div>
                            <h1>1. Punchout Settings</h1>
                            <Row type="flex" gutter={16}>
                                <Col style={{ width: 400 }}>
                                    <Spin spinning={!this.state.syncedPunchout}>

                                        <Card title="Generic Punchout Settings">
                                            <Row gutter={8} style={{ marginBottom: 16 }} type="flex">
                                                <Col>
                                                    <h4>Enable Punchout</h4>
                                                </Col>
                                                <Col>
                                                    <Switch checked={enterprise.punchoutModule} onChange={this.handleTogglePunchoutModule} />
                                                </Col>
                                            </Row>
                                            <Row gutter={8} style={{ marginBottom: 16 }} type="flex">
                                                <Col>
                                                    <h4 >Send POOM encode type</h4>
                                                </Col>
                                                <Col>
                                                    <Switch checked={enterprise.punchoutSendPoomEncodeType} onChange={this.handleTogglePunchoutSendPoomEncodeType} />
                                                </Col>
                                            </Row>
                                            <Row gutter={8} style={{ marginBottom: 16 }} type="flex">
                                                <Col>
                                                    <h4 >Payment proxy Punchout disabled</h4>
                                                </Col>
                                                <Col>
                                                    <Switch checked={enterprise.punchoutIsPaymentProxyDisabled} onChange={this.handleTogglePunchoutIsPaymentProxyDisabled} />
                                                </Col>
                                            </Row>


                                            <h4>Punchout Tax Configuration</h4>
                                            <Row style={{ marginBottom: 16 }} >
                                                <Col>
                                                    <Select
                                                        mode="default"
                                                        value={enterprise.punchoutTaxConfiguration}
                                                        onChange={this.handleOnChangePunchoutTaxConfiguration}

                                                        style={{ width: "100%" }}>
                                                        {
                                                            Object.keys(this.getEnterprisePunchoutTaxConfigurationsHashmap()).map(
                                                                punchoutTaxConfigurationKey => {

                                                                    const punchoutTaxConfigurationTax = this.getEnterprisePunchoutTaxConfigurationsHashmap()[punchoutTaxConfigurationKey];
                                                                    return (
                                                                        <Option
                                                                            key={punchoutTaxConfigurationKey}
                                                                            value={punchoutTaxConfigurationKey}
                                                                        >
                                                                            {punchoutTaxConfigurationTax}
                                                                        </Option>
                                                                    );
                                                                }
                                                            )
                                                        }
                                                    </Select>

                                                </Col>
                                            </Row>


                                            <h4>Punchout Application</h4>
                                            <Input
                                                onChange={this.handleUpdatePunchoutValues}
                                                name="punchoutApplication"
                                                value={enterprise.punchoutApplication} />

                                            <h4>Punchout Lead Time</h4>
                                            <Input
                                                onChange={this.handleUpdatePunchoutValues}
                                                name="punchoutLeadTime"
                                                value={enterprise.punchoutLeadTime} />

                                            <Divider />
                                            <EnterpriseUomMapping
                                                key={enterprise._id}
                                                value={enterprise.punchoutUomMapping}
                                                onSave={this.handleSavePunchoutUomMapping} />
                                        </Card>

                                    </Spin>


                                </Col>
                            </Row>

                            <h1>2. CXML or OCI</h1>

                            <Row type="flex" gutter={32}>
                                <Col span={12}>
                                    <Card title="CXML Punchout">

                                        <h4>Punchout Buyer Id</h4>
                                        <Input
                                            onChange={this.handleUpdatePunchoutValues}
                                            name="punchoutBuyerId"
                                            value={enterprise.punchoutBuyerId} />

                                        <h4>Punchout Seller Id</h4>
                                        <Input
                                            onChange={this.handleUpdatePunchoutValues}
                                            name="punchoutSellerId"
                                            value={enterprise.punchoutSellerId} />

                                        <h4>Punchout Network Id</h4>
                                        <Input
                                            onChange={this.handleUpdatePunchoutValues}
                                            name="punchoutNetworkId"
                                            value={enterprise.punchoutNetworkId} />


                                        <h4>Punchout Shared Secret</h4>
                                        <Input
                                            onChange={this.handleUpdatePunchoutValues}
                                            name="punchoutSharedSecret"
                                            value={enterprise.punchoutSharedSecret} />

                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <EnterpriseOciPunchoutCredentials enterprise={enterprise} />
                                </Col>
                            </Row>
                        </div>

                    </Tabs.TabPane>

                    <Tabs.TabPane key="settings" tab="Settings">

                        <Spin spinning={!this.state.syncedGenericDetails}>
                            {/* <Row type="flex"> */}
                            {/* <Col style={{ width: 300 }}> */}
                            {this.renderGenericDetails()}
                            {/* </Col> */}
                            {/* </Row> */}
                        </Spin>

                    </Tabs.TabPane>

                    <Tabs.TabPane key="custom-fields" tab="Custom Fields">
                        <EnterpriseCustomFields
                            key={this.state.randomKey}
                            enterprise={enterprise}
                            onUpdateSuccess={this.getAndSetEnterpriseData}
                            onCancelEditing={this.getAndSetEnterpriseData}
                        />
                    </Tabs.TabPane>

                </Tabs>
            </Card>
        );
    }

    renderCreditLimit = () => {

        const { enterprise, renderCreditChanger, newCreditLimit } = this.state;
        const isFluidActive = enterprise.paymentMethodsAvailable.some(p => p === "fluid");

        const canChangeCredit = CAN_CHANGE_CREDIT_EMAILS.includes(this.props.userData.data.local.email);

        return (
            <div>
                <Input
                    disabled={isFluidActive || !canChangeCredit}
                    onClick={() => this.setState({ renderCreditChanger: true })}
                    value={isFluidActive ? "N/A" : enterprise['creditLimit']}
                />
                {renderCreditChanger && canChangeCredit &&
                    <Card style={{ width: '60%', margin: 16 }} title="New Limit">
                        <Row align="middle" type="flex" justify="space-between">
                            <Input
                                style={{ width: '100%' }}
                                onChange={(e) => this.setState({ newCreditLimit: e.target.value })}
                            />
                        </Row>
                        <Row style={{ marginTop: 12 }} type="flex" justify="end">
                            <Button
                                style={{ marginRight: 12 }}
                                onClick={this.handleCancelUpdateCreditLimit}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => this.handleUpdateCreditLimit({ creditLimit: newCreditLimit })}
                                disabled={!this.state.newCreditLimit}
                                type='primary'
                            >Confirm</Button>
                        </Row>
                    </Card>
                }
            </div>
        );
    };

    renderCreditTermDays = () => {

        const { enterprise } = this.state;
        const isFluidActive = enterprise.paymentMethodsAvailable.some(p => p === "fluid");

        const canChangeCredit = CAN_CHANGE_CREDIT_EMAILS.includes(this.props.userData.data.local.email);

        return (
            <div>
                <Input
                    disabled={isFluidActive || !canChangeCredit}
                    onChange={this.handleUpdateGenericDetails}
                    name="creditTermDays"
                    value={isFluidActive ? "N/A" : this.state.enterprise["creditTermDays"]}
                />
            </div>
        );
    };

    renderDomainNames = () => {

        let domainNames = (this.state.enterprise.domainNames.length == 0 || !this.state.enterprise.domainNames) ? ['placeholder.com'] : this.state.enterprise.domainNames;

        return (
            <Row>
                {domainNames.map((_domainName, index) => (
                    <Row type='flex' gutter={12}>
                        <Col span={20}>
                            <Input
                                value={_domainName}
                                onChange={(e) => this.handleUpdateDomainNames(e, index)}
                                style={{ width: '100%' }}
                                placeholder="eezee.sg"
                            />
                        </Col>
                        <Col span={2}>
                            <Button
                                onClick={() => this.handleSubtractDomainName(index)}
                            ><Icon type="minus" /></Button>
                        </Col>
                        {index == domainNames.length - 1 &&
                            <Col span={2}>
                                <Button
                                    onClick={this.handleAddDomainName}
                                ><Icon type="plus" /></Button>
                            </Col>}
                    </Row>
                ))}
            </Row>
        );
    };

    renderIsTest = () => (
        <Switch
            checkedChildren="test"
            unCheckedChildren="live"
            checked={this.state.enterprise.isTest}
            onChange={(checked) => this.handleUpdateGenericDetails({ target: { name: 'isTest', value: checked } })}
        />
    );

    renderCodeTags = (key) => (
        <Input.TextArea
            autoSize={{ minRows: 3, maxRows: 12 }}
            style={{ width: '100%' }}
            placeholder="One code per line (paste from Excel)"
            value={(this.state.enterprise[key] || []).join('\n')}
            onChange={(e) => this.handleUpdateGenericDetails({ target: { name: key, value: e.target.value.split('\n') } })}
        />
    );

    renderForBDUse = () => {
        const details = [{
            title: 'Lead',
            key: 'salesAgent',
            renderInput: this.renderSalesAgent
        }, {
            title: 'Size',
            key: 'size',
            renderInput: this.renderSize
        }, {
            title: 'Wallet',
            key: 'wallet',
            renderInput: this.renderWallet
        }];

        return (
            <Row style={{ marginTop: 16 }}>
                <Col>
                    <Divider />
                    <h2>For Business Dev Team Use</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridRowGap: 12 }}>
                        {details.map(_detail => (
                            <div>
                                <h4>{_detail.title}</h4>
                                {_detail.renderInput ?
                                    _detail.renderInput(_detail.params)
                                    :
                                    <Input onChange={this.handleUpdateGenericDetails}
                                        name={_detail.key}
                                        value={this.state.enterprise[_detail.key]}
                                    />}
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
        );
    };

    renderGenericDetails = () => {

        const { enterprise } = this.state;

        const details = [
            {
                title: 'Company Name',
                key: 'companyName'
            }, {
                title: 'Mov Free Delivery',
                key: 'movFreeDelivery'
            }, {
                title: 'Domain Name',
                key: 'domainName'
            }, {
                title: 'Logo Url',
                key: 'logoUrl',
                renderInput: this.renderLogoUrl
            }, {
                title: 'Credit Limit',
                key: 'creditLimit',
                renderInput: this.renderCreditLimit
            }, {
                title: 'Credit Term Days',
                key: 'creditTermDays',
                renderInput: this.renderCreditTermDays
            }, {
                title: 'Short Name',
                key: 'shortName'
            }, {
                title: 'Domain Names',
                key: 'domainNames',
                renderInput: this.renderDomainNames
            }, {
                title: 'Cc Invoice To Email',
                key: 'ccEveryInvoiceToEmail',
                renderInput: this.renderCc,
                params: 'ccEveryInvoiceToEmail'
            }, {
                title: 'Cc In Stock Email',
                key: 'ccInStockEmail',
                renderInput: this.renderCc,
                params: 'ccInStockEmail'
            }, {
                title: 'Remarks',
                key: 'remarks',
                renderInput: this.renderRemarks
            }, {
                title: 'Finance Remarks',
                key: 'financeRemarks',
                renderInput: this.renderFinanceRemarks
            }, {
                title: 'Platform Fee',
                key: 'platformFee',
                renderInput: this.renderPlatformFee
            }, {
                title: 'Department Codes',
                key: 'departmentCodes',
                renderInput: this.renderCodeTags,
                params: 'departmentCodes'
            }, {
                title: 'Sub Department Codes',
                key: 'subDepartmentCodes',
                renderInput: this.renderCodeTags,
                params: 'subDepartmentCodes'
            }, {
                title: 'Test Account',
                key: 'isTest',
                renderInput: this.renderIsTest
            },];

        let renderEnterpriseTierZeroSettings = () => null;

        const enterpriseWithCustomizablePaymentOptions = ["0", "1A", "2A"];

        if (enterprise && enterprise.tier && enterpriseWithCustomizablePaymentOptions.includes(enterprise.tier)) {
            renderEnterpriseTierZeroSettings = () => {

                const options = [
                    {
                        label: "Eezee Credits",
                        value: "credit"
                    },
                    {
                        label: "Credit Card",
                        value: "card"
                    },
                    {
                        label: "Paypal",
                        value: "paypal"
                    },
                    {
                        label: "SG Paynow",
                        value: "paynow"
                    },
                    {
                        label: "Fluid",
                        value: "fluid"
                    }
                ];

                return (
                    <Row style={{ marginTop: 16 }}>
                        <Col>
                            <Divider />
                            <h2>Enterprise Tier 0 Settings</h2>
                            <h3>Payment Options</h3>
                            <Checkbox.Group
                                name="paymentMethodsAvailable"
                                options={options}
                                onChange={value => this.handleUpdateGenericDetails(
                                    {
                                        target: {
                                            name: "paymentMethodsAvailable",
                                            value
                                        }
                                    }
                                )}
                                value={enterprise.paymentMethodsAvailable} />
                        </Col>
                    </Row>
                );
            };
        }

        return (
            <div>
                <Row type="flex" gutter={16}>
                    {details.map(_detail => (
                        <Col span={12}>
                            <h4>{_detail.title}</h4>
                            {_detail.renderInput ?
                                _detail.renderInput(_detail.params)
                                :
                                <Input
                                    onChange={this.handleUpdateGenericDetails}
                                    name={_detail.key}
                                    value={this.state.enterprise[_detail.key]}
                                />}
                        </Col>
                    ))}
                </Row>
                <Divider />
                <Row style={{ marginTop: 28 }}>
                    {this.renderERPDetails()}
                </Row>
                {renderEnterpriseTierZeroSettings()}
                <EezeePaymentDetails
                    enterprise={this.state.enterprise}
                    onPaymentDetailsChange={this.onPaymentDetailsChange}
                />
                {this.renderForBDUse()}
            </div>
        );
    };

    renderERPDetails = () => {
        const details = [{
            title: 'ERP - Auto Send AR Invoice',
            key: 'autoSendArInvoice',
            renderInput: this.renderAutoSendArInvoice
        },
        {
            title: 'ERP - Auto Send POD Completion',
            key: 'autoSendPodCompletion',
            renderInput: this.renderAutoSendPodCompletion
        },
        {
            title: 'ERP - Consolidate AR Invoice',
            key: 'consolidateArInvoiceFlags',
            renderInput: this.renderConsolidatedArInvoices
        },
        {
            title: 'ERP - Send To Finance Email Only',
            key: 'sendArInvoiceToFinanceEmailOnly',
            renderInput: this.renderSendArToFinanceEmailOnly
        }, {
            title: 'ERP - Add Quotation CC Email',
            key: 'quotationCcEmail',
            renderInput: this.renderQuotationCcEmail
        }];

        return (
            <div>
                <Row type="flex" gutter={16}>
                    {details.map(_detail => (
                        <Col span={8} style={{ marginBottom: 20 }}>
                            <h4>{_detail.title}</h4>
                            {_detail.renderInput ?
                                _detail.renderInput(_detail.params)
                                :
                                <Input
                                    onChange={this.handleUpdateGenericDetails}
                                    name={_detail.key}
                                    value={this.state.enterprise[_detail.key]}
                                />}
                        </Col>
                    ))}
                </Row>
            </div>
        );
    };

    // Keys determine which ccList on enterprise Object to edit
    // keys = ['ccEveryInvoiceToEmail','ccInStockEmail']
    renderCc = (key) => {

        const ccEmails = this.state.enterprise[key] || [];

        var titles = {
            ccEveryInvoiceToEmail: "Emails to CC Invoice",
            ccInStockEmail: "Email to CC In Stock Email"
        };

        return (
            <div>
                <Modal
                    onCancel={() => {
                        this.setState({
                            [`ccModalVisible_${key}`]: false
                        });
                    }}
                    onOk={() => this.setState({ [`ccModalVisible_${key}`]: false })}
                    afterClose={() => {
                        this.setState({
                            activeCcEmail: ''
                        });
                    }}
                    title={titles[key]}
                    closable={false}
                    centered visible={this.state[`ccModalVisible_${key}`]}
                >
                    <Input
                        value={this.state.activeCcEmail}
                        onPressEnter={() => this.handleAddCcEmail(key)}
                        onChange={(e) => this.setState({ activeCcEmail: e.target.value })}
                        style={{ width: 400 }} />
                    {ccEmails.map(_email => (
                        <div style={{ paddingTop: 24 }}>
                            {_email}
                            <a
                                onClick={() => this.handleRemoveCcEmail(_email, key)}
                                style={{ marginLeft: 24 }}>Remove</a>
                        </div>
                    ))}
                </Modal>
                <Button
                    onClick={() => this.setState({ [`ccModalVisible_${key}`]: true })}
                    style={{ marginBottom: 16 }}
                >
                    {ccEmails ? ccEmails.length : 0} CC Emails
                </Button>
            </div>
        );
    };

    renderPlatformFee = () => {

        const { platformFeeActive, platformFee } = this.state.enterprise;
        const DEFAULT_PLATFORM_FEE = 7;

        return (
            <div>
                <Switch
                    checkedChildren="active"
                    unCheckedChildren="inactive"
                    checked={platformFeeActive}
                    onChange={(active) => this.onPlatformFeeChange(active, active ? DEFAULT_PLATFORM_FEE : 0)}
                    style={{ marginRight: 8 }}
                />
                {platformFeeActive &&
                    <InputNumber
                        value={platformFee}
                        onChange={(e) => this.onPlatformFeeChange(platformFeeActive, e)}
                    />
                }
            </div>

        );

    };

    renderRemarks = () => {
        const { TextArea } = Input;
        const { enterprise, renderRemarksChanger, newRemarks } = this.state;

        return (
            <div>
                <TextArea
                    onClick={() => this.setState({ renderRemarksChanger: true })}
                    value={enterprise.remarks || 'Click to add remarks...'}
                    placeholder="Click to add remarks..."
                    readOnly
                    style={{ cursor: 'pointer' }}
                />
                {renderRemarksChanger &&
                    <Card style={{ width: '80%', margin: 16 }} title="Enterprise Remarks">
                        <Row align="middle" type="flex" justify="space-between">
                            <TextArea
                                rows={6}
                                style={{ width: '100%' }}
                                placeholder="Add remarks about this enterprise..."
                                onChange={(e) => this.setState({ newRemarks: e.target.value })}
                                value={newRemarks !== undefined ? newRemarks : enterprise.remarks || ''}
                                autoFocus
                            />
                        </Row>
                        <Row style={{ marginTop: 12 }} type="flex" justify="end">
                            <Button
                                style={{ marginRight: 12 }}
                                onClick={this.handleCancelUpdateRemarks}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={this.handleUpdateRemarks}
                                type='primary'
                            >
                                Save
                            </Button>
                        </Row>
                    </Card>
                }
            </div>
        );
    };

    renderFinanceRemarks = () => {
        const { TextArea } = Input;
        const { enterprise, renderFinanceRemarksChanger, newFinanceRemarks } = this.state;

        const { ezBoss, ezFinance } = this.props.userData.data.permissions;
        const hasPemissionsToEditFinanceRemarks = ezBoss || ezFinance;


        return (
            <div>
                <TextArea
                    onClick={() => this.setState({ renderFinanceRemarksChanger: true })}
                    value={enterprise.financeRemarks || 'Click to add finance remarks...'}
                    placeholder="Click to add finance remarks..."
                    readOnly
                    style={{ cursor: 'pointer' }}
                />
                {hasPemissionsToEditFinanceRemarks && renderFinanceRemarksChanger &&
                    <Card style={{ width: '80%', margin: 16 }} title="Finance Remarks">
                        <Row align="middle" type="flex" justify="space-between">
                            <TextArea
                                rows={6}
                                style={{ width: '100%' }}
                                placeholder="Add finance remarks about this enterprise..."
                                onChange={(e) => this.setState({ newFinanceRemarks: e.target.value })}
                                value={newFinanceRemarks !== undefined ? newFinanceRemarks : enterprise.financeRemarks || ''}
                                autoFocus
                            />
                        </Row>
                        <Row style={{ marginTop: 12 }} type="flex" justify="end">
                            <Button
                                style={{ marginRight: 12 }}
                                onClick={this.handleCancelUpdateFinanceRemarks}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={this.handleUpdateFinanceRemarks}
                                type='primary'
                            >
                                Save
                            </Button>
                        </Row>
                    </Card>
                }
            </div>
        );
    };

    renderAutoSendArInvoice = () => {

        const { autoSendArInvoice } = this.state.enterprise;

        return (
            <div>
                <Switch
                    checkedChildren="active"
                    unCheckedChildren="inactive"
                    checked={autoSendArInvoice}
                    onChange={(active) => this.onAutoSendArInvoiceChange(active)}
                    style={{ marginRight: 8 }}
                />
            </div>

        );

    };

    renderAutoSendPodCompletion = () => {

        const { autoSendPodCompletion } = this.state.enterprise;

        return (
            <div>
                <Switch
                    checkedChildren="active"
                    unCheckedChildren="inactive"
                    checked={autoSendPodCompletion}
                    onChange={(active) => this.onAutoSendPodCompletionChange(active)}
                    style={{ marginRight: 8 }}
                />
            </div>

        );

    };

    renderConsolidatedArInvoices = () => {

        /**
         * Switch Inactive to Active => Sets `consolidateArInvoice` to true
         * Select consolidateArInvoice radio => Sets `consolidateArInvoice` to true, server sets `consolidateArInvoiceBySo` to false
         * Select consolidateArInvoiceBySo radio => Sets `consolidateArInvoiceBySo` to true, server sets `consolidateArInvoice` to false
         * Select Active to Inactive => Sets both flags to false on server
         * 
         * By default when all flags are false. Show Consolidate AR Invoice radio button is checked (data is still false)
         */

        const { consolidateArInvoice, consolidateArInvoiceBySo } = this.state.enterprise;
        const isSwitchActive = consolidateArInvoice || consolidateArInvoiceBySo;
        const canChangeCredit = CAN_CHANGE_CREDIT_EMAILS.includes(this.props.userData.data.local.email);

        let radioGroupValue = "consolidateArInvoice";
        if (consolidateArInvoice && consolidateArInvoiceBySo) {
            message.destroy();
            message.error("Error: Multiple consolidate AR Invoice options set! Reach out to Product Team!");
        }

        if (consolidateArInvoice) {
            radioGroupValue = "consolidateArInvoice";
        }
        if (consolidateArInvoiceBySo) {
            radioGroupValue = "consolidateArInvoiceBySo";
        }



        return (
            <div>
                <Row type="flex" gutter={24}>
                    <Col>
                        <Switch
                            checkedChildren="active"
                            unCheckedChildren="inactive"
                            checked={isSwitchActive}
                            disabled={!canChangeCredit}
                            onChange={(e) => {
                                this.onToggleArInvoiceFlagSwitch(e);
                            }}
                        />
                    </Col>
                    <Col>
                        <Radio.Group
                            disabled={!isSwitchActive || !canChangeCredit}
                            value={radioGroupValue}
                            onChange={this.onConsolidateArInvoiceFlagsChange}
                        >
                            <div style={{ marginBottom: 8 }}>
                                <Radio value="consolidateArInvoiceBySo">
                                    Sales Order
                                </Radio>
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <Radio value="consolidateArInvoice" defaultChecked>
                                    Billing Cut-off Date
                                </Radio>
                            </div>
                            <div>
                                {this.renderbillingCutOffDates()}
                            </div>
                        </Radio.Group>
                    </Col>
                </Row>
            </div>
        );
    };

    renderSendArToFinanceEmailOnly = () => {

        const { sendArInvoiceToFinanceEmailOnly, financeEmail } = this.state.enterprise;

        return (
            <div>
                <Row type="flex" gutter={24}>
                    <Switch
                        checkedChildren="active"
                        unCheckedChildren="inactive"
                        checked={sendArInvoiceToFinanceEmailOnly}
                        onChange={(active) => this.onSendArInvoiceToFinanceEmailOnlyChange(active)}
                        style={{ marginRight: 8 }}
                    />
                    <Input
                        disabled={!sendArInvoiceToFinanceEmailOnly}
                        defaultValue={financeEmail}
                        style={{ width: 200 }}
                        onChange={(e) => this.setState({ newFinanceEmail: e.target.value })}
                    />
                    <Button
                        onClick={() => this.handleUpdateFinanceEmail({ financeEmail: this.state.newFinanceEmail })}
                        disabled={!sendArInvoiceToFinanceEmailOnly && !this.state.newFinanceEmail}
                        type='primary'>
                        Confirm
                    </Button>
                    <Row style={{ marginTop: 12 }} type="flex" justify="end">
                    </Row>
                </Row>
            </div>

        );

    };

    renderQuotationCcEmail = () => {

        const { quotationCcEmail } = this.state.enterprise;

        return (
            <div>
                <Row gutter={24} stlye={{ marginLeft: 8 }}>
                    <Col>
                        <Input
                            defaultValue={quotationCcEmail}
                            style={{ width: 200 }}
                            onChange={(e) => this.setState({ newQuotationCcEmail: e.target.value })}
                        />
                        <Button
                            onClick={() => this.handleUpdateQuotationCcEmail({ quotationCcEmail: this.state.newQuotationCcEmail })}
                            type='primary'>
                            Confirm
                        </Button>
                    </Col>
                </Row>
            </div>

        );

    };

    renderbillingCutOffDates = () => {

        const { billingCutOffDates } = this.state.enterprise;
        const billingCutOffDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 99];
        const canChangeCredit = CAN_CHANGE_CREDIT_EMAILS.includes(this.props.userData.data.local.email);
        const isDisabled = !Boolean(this.state.enterprise.consolidateArInvoice) || !canChangeCredit;
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 8
            }}>
                <Select
                    disabled={isDisabled}
                    mode="multiple"
                    value={billingCutOffDates}
                    onChange={(val) => this.onBillingCutOffDatesChange(val)}
                    style={{ width: 150 }}>
                    {billingCutOffDays.map(_key => {
                        const text = _key === 99 ? 'Last' : _key;
                        return (
                            <Option value={_key}>
                                {text}
                            </Option>
                        );
                    }
                    )}
                </Select>
                <div>
                    day of the month
                </div>
            </div>

        );

    };

    renderLogoUrl = () => {

        const { logoUrl } = this.state.enterprise;

        return (
            <div>
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .enterprise-image-upload .ant-upload {
                        height: 70%;
                    }
                `}} />
                <Upload.Dragger
                    className="enterprise-image-upload"
                    action={`${API_ENDPOINT}/api/upload/enterprise-image`}
                    name='picture'
                    accept="image/*"
                    onChange={this.handleLogoChange}
                    withCredentials={true}
                >
                    {logoUrl ?
                        <img src={logoUrl} style={{ height: 150 }} />
                        :
                        <div>
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox" />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                        </div>
                    }
                </Upload.Dragger>
            </div>
        );

    };

    renderTag = ({ userId, key, color }) => {
        return (
            <Tag
                color={color}
                style={{ cursor: 'pointer' }}
                onClick={() => this.handleTogglePermission(userId, key)}
            >
                {key}
            </Tag>
        );
    };

    renderTiers = () => {

        const { enterprise } = this.state;

        const modules = {
            CATALOG: "catalog",
            FINANCE: "finance",
            APPROVAL: 'approval',
            CONTRACT: 'contract'
        };

        const sets = [{
            key: '0',
            modules: []
        }, {
            key: '1A',
            modules: [modules.CATALOG]
        }, {
            key: '1B',
            modules: [modules.APPROVAL]
        }, {
            key: '2A',
            modules: [modules.CATALOG, modules.FINANCE]
        }, {
            key: '2B',
            modules: [modules.CATALOG, modules.APPROVAL]
        }, {
            key: '3',
            modules: [modules.CATALOG, modules.FINANCE, modules.APPROVAL]
        }];

        return (
            <div>
                <style dangerouslySetInnerHTML={{
                    __html: `
                .module-tier:hover {
                    opacity:0.8;
                }
                
                .module-tier {
                    height: 180px;
                    margin-bottom: 12px; 
                    cursor: pointer;
                }
                `}} />
                <Row type="flex" gutter={12}>
                    {sets.map(_set => (
                        <Col span={6}>
                            <Card
                                onClick={() => this.handleSelectModuleTier({ tier: _set.key, modules: _set.modules })}
                                className="module-tier"
                                title={<div>Tier {_set.key} {enterprise.tier == _set.key && <Tag style={{ marginLeft: 12 }} color="rgb(82, 196, 26)">Selected</Tag>}</div>}
                            >
                                {_set.modules.map(_module => (
                                    <div>
                                        {_module[0].toUpperCase() + _module.slice(1)}
                                    </div>
                                ))}
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        );

    };

    renderSalesAgent = () => {

        const { enterprise } = this.state;

        return (
            <SalesAgentSelector
                activeAgent={enterprise.salesAgent && enterprise.salesAgent._id}
                onSelect={this.onAgentChange}
            />
        );
    };

    renderSize = () => {

        const { enterprise } = this.state;

        const ENTERPRISE_SIZE = {
            SMALL: 'small',
            MEDIUM: 'medium',
            LARGE: 'large',
            GROWTH: 'growth',
            KEY: 'key',
            NULL: null
        };

        return (
            <Select value={enterprise.size ? enterprise.size : null} style={{ width: 240 }} onChange={(e) => this.onSizeChange(e)}>
                {Object.keys(ENTERPRISE_SIZE).map(_key => {
                    return (
                        <Option value={ENTERPRISE_SIZE[_key]}>{_key}</Option>
                    );
                })}
            </Select>
        );
    };

    renderWallet = () => {

        const { enterprise } = this.state;

        return (
            <InputNumber width={240} min={1} value={enterprise.wallet ? enterprise.wallet : null} onChange={(e) => this.onWalletChange(e)} />
        );
    };

    constructor(props) {
        super(props);

        this.state = {
            randomKey: getRandomKey(),
            enterprise: false,
            enterpriseUsers: false,

            count: false,
            page: 1,
            limit: 5,
            searchTerm: "",

            syncedPunchout: true,
            syncedGenericDetails: true,

            loading: true,

            billingCutOffDate: 28,
            renderRemarksChanger: false,
            newRemarks: undefined,
            renderFinanceRemarksChanger: false,
            newFinanceRemarks: undefined
        };

        this.getAndSetEnterpriseData = this.getAndSetEnterpriseData.bind(this);
        this.handleSearch = debounce(this.handleSearch, 400);
        this.postPunchoutChangesToServer = debounce(this.postPunchoutChangesToServer, 800);
        this.postSettingsChangesToServer = debounce(this.postSettingsChangesToServer, 800);
        this.postBrandRestrictionChangesToServer = debounce(this.postBrandRestrictionChangesToServer, 800);
        this.postCategoryRestrictionChangesToServer = debounce(this.postCategoryRestrictionChangesToServer, 800);
        this.onWalletChange = debounce(this.onWalletChange, 800);

    }

    async componentWillMount() {

        await this.getAndSetEnterpriseData();
    }

    async getAndSetEnterpriseData() {
        const { page, limit, searchTerm } = this.state;

        const { enterpriseId } = this.props;

        Promise.all([
            _getEnterpriseData(enterpriseId),
            _getEnterpriseUsers({
                enterpriseId,
                page,
                limit,
                searchTerm
            })
        ])
            .then(([enterpriseRes, enterpriseUsersRes]) => {

                const { enterprise } = enterpriseRes.data;

                this.setState({
                    enterprise,
                    enterpriseUsers: enterpriseUsersRes.data.users,
                    count: enterpriseUsersRes.data.count,
                    loading: false,
                    randomKey: getRandomKey()
                });
            });
    }

    getEnterprisePunchoutTaxConfigurationsHashmap = () => {

        /**
         * Default value for is `Exclusive of tax`
         */
        return {
            "EXCLUSIVE_OF_TAX": "Exclusive of Tax",
            "INCLUSIVE_OF_TAX": "Inclusive of Tax",
            "EXCLUSIVE_AND_INCLUSIVE_OF_TAX": "Exclusive & Inclusive of Tax",
        };
    };

    getEnterpriseUsers = () => {
        const { page, limit, searchTerm } = this.state;

        const { enterpriseId } = this.props;

        _getEnterpriseUsers({
            enterpriseId,
            page,
            limit,
            searchTerm
        })
            .then(res => {
                this.setState({
                    enterpriseUsers: res.data.users,
                    count: res.data.count
                });
            });
    };

    handleRemoveCcEmail = (email, key) => {

        _postRemoveCcEmail({ email, enterpriseId: this.state.enterprise._id, key })
            .then(res => {
                this.setState({
                    enterprise: {
                        ...this.state.enterprise,
                        [key]: res.data.enterprise[key]
                    }
                });
            });

    };

    handleAddCcEmail = (key) => {

        const { activeCcEmail, enterprise } = this.state;

        const pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

        if (!pattern.test(activeCcEmail)) {
            return message.warning("Please enter a valid email!");
        }

        _postAddCcEmail({ email: activeCcEmail, enterpriseId: enterprise._id, key })
            .then(res => {
                this.setState({
                    enterprise: {
                        ...this.state.enterprise,
                        [key]: res.data.enterprise[key]
                    },
                    activeCcEmail: ''
                });
            });

    };

    handleLogoChange = (e) => {

        if (e.file.status == 'done') {
            this.setState({
                enterprise: {
                    ...this.state.enterprise,
                    "logoUrl": e.file.response.image.url
                }
            }, this.postSettingsChangesToServer);
        }

    };

    handleCancelUpdateCreditLimit = () => {
        this.setState({
            renderCreditChanger: false,
            newCreditLimit: false
        });
    };

    handleUpdateCreditLimit = ({ creditLimit }) => {

        _postUpdateEnterpriseCreditLimit({
            enterpriseId: this.props.enterpriseId,
            creditLimit
        })
            .then(res => {

                const { enterprise } = res.data;

                message.success(`Credit limit raised to ${enterprise.creditLimit.toFixed(2)}`);

                this.setState({
                    enterprise
                }, this.handleCancelUpdateCreditLimit);
            });

    };

    handleCancelUpdateRemarks = () => {
        this.setState({
            renderRemarksChanger: false,
            newRemarks: undefined
        });
    };

    handleUpdateRemarks = () => {
        const { newRemarks } = this.state;

        this.setState({
            enterprise: {
                ...this.state.enterprise,
                remarks: newRemarks || ''
            }
        }, () => {
            this.postSettingsChangesToServer();
            this.handleCancelUpdateRemarks();
            message.success('Remarks updated successfully');
        });
    };

    handleCancelUpdateFinanceRemarks = () => {
        this.setState({
            renderFinanceRemarksChanger: false,
            newFinanceRemarks: undefined
        });
    };

    handleUpdateFinanceRemarks = () => {
        const { newFinanceRemarks } = this.state;

        this.setState({
            enterprise: {
                ...this.state.enterprise,
                financeRemarks: newFinanceRemarks || ''
            }
        }, () => {
            this.postSettingsChangesToServer();
            this.handleCancelUpdateFinanceRemarks();
            message.success('Finance remarks updated successfully');
        });
    };

    handleUpdateFinanceEmail = ({ financeEmail }) => {

        if (!financeEmail) {
            return message.error("Please key in an email!");
        }

        let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        const email = financeEmail.trim();

        if (!emailRegex.test(email)) {
            message.destroy();
            return message.error("Please key in a valid email!");
        }

        _putFinanceEmail({
            financeEmail: financeEmail,
            enterpriseId: this.props.enterpriseId
        })
            .then(res => {

                const enterprise = res.data;

                message.success(`Finance Email changed to to ${enterprise.financeEmail}`);

                this.setState({
                    enterprise
                });
            });

    };

    handleUpdateQuotationCcEmail = ({ quotationCcEmail }) => {

        if (!quotationCcEmail) {
            return message.error("Please key in an email!");
        }

        let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        const email = quotationCcEmail.trim();

        if (!emailRegex.test(email)) {
            message.destroy();
            return message.error("Please key in a valid email!");
        }

        _putQuotationCcEmail({
            quotationCcEmail: quotationCcEmail,
            enterpriseId: this.props.enterpriseId
        })
            .then(res => {

                const enterprise = res.data;

                message.success(`Quotation Cc Email changed to to ${enterprise.quotationCcEmail}`);

                this.setState({
                    enterprise
                });
            });

    };

    handleSubtractDomainName = (index) => {

        let domainNames = [...this.state.enterprise.domainNames];

        domainNames.splice(index, 1);

        this.setState({
            enterprise: {
                ...this.state.enterprise,
                'domainNames': domainNames
            }
        }, this.postSettingsChangesToServer);

    };

    handleAddDomainName = () => {

        this.setState({
            enterprise: {
                ...this.state.enterprise,
                'domainNames': [...this.state.enterprise.domainNames, this.state.enterprise.domainNames[0]]
            }
        }, this.postSettingsChangesToServer);

    };


    handleUpdateDomainNames = (e, index) => {

        const { domainNames } = this.state.enterprise;

        let updatedDomainNames = [...domainNames.slice(0, index), e.target.value, ...domainNames.slice(index + 1)];


        this.setState({
            enterprise: {
                ...this.state.enterprise,
                'domainNames': updatedDomainNames
            }
        }, this.postSettingsChangesToServer);


    };

    handleOnChangeSearch = (e) => {
        this.handleSearch(e.target.value);
    };

    handleOnChangeTab = (e) => {

        this.props.history.push(`/enterprise/${this.props.enterpriseId}/${e}`);

    };

    handleOnChangeUploadStatus = (info) => {

        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {

            message.success(`${info.file.name} file uploaded successfully`);

            this.setState({
                enterprise: {
                    ...this.state.enterprise,
                    addresses: info.file.response.addresses
                }
            });

        } else if (info.file.status === 'error') {
            // console.log( info.response.data );
            message.error(`${info.file.name} file upload failed.`);
            message.error(info.file.response);
        }

    };


    handlePageChange = (page) => {
        this.setState({ page }, this.getEnterpriseUsers);
    };

    handleSearch = (searchTerm) => {
        this.setState({
            searchTerm,
            page: 1
        }, this.getEnterpriseUsers);
    };

    handleRemove = (userId) => {
        _postRemoveUserFromEnterprise({
            enterpriseId: this.props.enterpriseId,
            userId
        })
            .then(res => {
                this.getEnterpriseUsers();
            });
    };

    handleTogglePermission = (userId, key) => {
        _postToggleEnterprisePermission({ userId, key })
            .then(res => {
                this.getEnterpriseUsers();
            });
    };

    handleTogglePunchoutModule = () => {
        this.setState({
            enterprise: {
                ...this.state.enterprise,
                punchoutModule: !this.state.enterprise.punchoutModule
            }
        }, this.postPunchoutChangesToServer);
    };

    handleTogglePunchoutSendPoomEncodeType = () => {
        this.setState({
            enterprise: {
                ...this.state.enterprise,
                punchoutSendPoomEncodeType: !this.state.enterprise.punchoutSendPoomEncodeType
            }
        }, this.postPunchoutChangesToServer);
    };

    handleTogglePunchoutIsPaymentProxyDisabled = () => {
        this.setState({
            enterprise: {
                ...this.state.enterprise,
                punchoutIsPaymentProxyDisabled: !this.state.enterprise.punchoutIsPaymentProxyDisabled
            }
        }, this.postPunchoutChangesToServer);
    };

    handleSelectModuleTier = ({ tier, modules }) => {

        if (this.state.enterprise.isLive) {
            return message.error("Enterprise must be offline to switch tier!");
        }

        _postSetEnterpriseModuleTier({ enterpriseId: this.state.enterprise._id, tier, modules })
            .then(res => {
                this.setState({
                    enterprise: res.data.enterprise
                });
            });

    };


    handleUpdateGenericDetails = async (e, config = { postToServer: true }) => {

        const oldEnterpriseState = this.state.enterprise;

        this.setState({
            enterprise: {
                ...this.state.enterprise,
                [e.target.name]: e.target.value
            }
        });

        if (config.postToServer) {
            await this.postSettingsChangesToServer(oldEnterpriseState);
        }

    };

    handleUpdatePunchoutValues = (e) => {
        this.setState({
            enterprise: {
                ...this.state.enterprise,
                [e.target.name]: e.target.value
            }
        }, this.postPunchoutChangesToServer);
    };

    // punchoutUomMapping is deliberately not included: the server leaves the
    // stored map untouched when the key is absent, so the debounced autosave
    // cannot wipe it. It is only sent from handleSavePunchoutUomMapping.
    getPunchoutSettingsPayload = () => {

        const {
            punchoutModule,
            punchoutSendPoomEncodeType,
            punchoutBuyerId,
            punchoutSellerId,
            punchoutNetworkId,
            punchoutSharedSecret,
            punchoutApplication,
            punchoutLeadTime,
            punchoutTaxConfiguration,
            punchoutIsPaymentProxyDisabled
        } = this.state.enterprise;

        const { enterpriseId } = this.props;

        return {
            punchoutModule,
            punchoutSendPoomEncodeType,
            punchoutBuyerId,
            punchoutSellerId,
            punchoutNetworkId,
            punchoutSharedSecret,
            enterpriseId,
            punchoutApplication,
            punchoutLeadTime,
            punchoutTaxConfiguration,
            punchoutIsPaymentProxyDisabled
        };
    };

    handleSavePunchoutUomMapping = async (punchoutUomMapping) => {
        await _postUpdateEnterprisePunchoutSettings({
            ...this.getPunchoutSettingsPayload(),
            punchoutUomMapping
        });
        this.setState({
            enterprise: {
                ...this.state.enterprise,
                punchoutUomMapping
            }
        });
    };

    postPunchoutChangesToServer = () => {

        this.setState({ syncedPunchout: false }, () => {

            _postUpdateEnterprisePunchoutSettings(this.getPunchoutSettingsPayload())
                .then(res => {

                    setTimeout(() => {
                        this.setState({ syncedPunchout: true });
                    }, 500);
                });

        });
    };

    handleSaveCheckoutThreshold = ({
        checkoutThreshold,
    }) => {
        const prevEnterprise = this.state.enterprise;

        // pass the old state so a failed save rolls back instead of blanking the page
        this.setState({
            enterprise: {
                ...prevEnterprise,
                checkoutThreshold
            }
        }, () => this.postSettingsChangesToServer(prevEnterprise));
    };

    postSettingsChangesToServer = (prevEnterpriseState) => {

        const {
            companyName,
            movFreeDelivery,
            logoUrl,
            domainName,
            dayOfDelivery,
            deliveryBuffer,
            shortName,
            creditTermDays,
            creditLimit,
            domainNames,
            paymentMethodsAvailable,
            remarks,
            financeRemarks,
            departmentCodes,
            subDepartmentCodes,
            isTest,
            checkoutThreshold
        } = this.state.enterprise;

        const { enterpriseId } = this.props;

        this.setState({ syncedGenericDetails: false }, () => {

            _postUpdateEnterpriseSettings({
                companyName,
                movFreeDelivery,
                logoUrl,
                domainName,
                enterpriseId,
                dayOfDelivery,
                deliveryBuffer,
                shortName,
                creditTermDays,
                creditLimit,
                domainNames,
                paymentMethodsAvailable,
                remarks,
                financeRemarks,
                departmentCodes,
                subDepartmentCodes,
                isTest,
                checkoutThreshold
            })
                .then(res => {

                    setTimeout(() => {
                        this.setState({
                            syncedGenericDetails: true,
                            enterprise: {
                                ...this.state.enterprise,
                                ...res.data.settings
                            }
                        });
                    }, 500);

                })
                .catch(err => {
                    this.setState({
                        syncedGenericDetails: true,
                        enterprise: prevEnterpriseState
                    });
                });

        });
    };

    onAgentChange = ({ agentId, agentEmail }) => {

        const { enterpriseId } = this.props;

        _postUpdateSalesAgent({ agentId, agentEmail, enterpriseId })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
            });
    };

    onSizeChange = (value) => {

        const { enterpriseId } = this.props;

        _postUpdateSize({ size: value, enterpriseId })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
            });
    };

    onWalletChange = (value) => {

        const { enterpriseId } = this.props;

        if (typeof (value) !== 'number') {
            message.error('Please input a valid value for Wallet!', 10);
            return;
        }

        _postUpdateWallet({ wallet: value, enterpriseId })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Wallet Updated!`);
            });
    };

    onPaymentDetailsChange = (mktBaseCurrency, paymentDetailsName) => {

        const { enterpriseId } = this.props;

        _putPaymentDetails({
            mktBaseCurrency,
            paymentDetailsName,
            enterpriseId
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Eezee Payment Details Updated!`);
            });
    };

    onPlatformFeeChange = (platformFeeActive, platformFee) => {

        const { enterpriseId } = this.props;

        _putPlatformFee({
            platformFeeActive,
            platformFee,
            enterpriseId
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Platform Fee Updated!`);
            });
    };

    onAutoSendArInvoiceChange = (autoSendArInvoice) => {

        const { enterpriseId } = this.props;

        _putAutoSendArInvoice({
            autoSendArInvoice,
            enterpriseId
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Auto Send Ar Invoice Updated!`);
            });
    };

    onAutoSendPodCompletionChange = (autoSendPodCompletion) => {

        const { enterpriseId } = this.props;

        _putAutoSendPodCompletion({
            autoSendPodCompletion,
            enterpriseId
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Auto Send POD Completion Updated!`);
            });
    };

    onSendArInvoiceToFinanceEmailOnlyChange = (sendArInvoiceToFinanceEmailOnly) => {

        const { enterpriseId } = this.props;

        _putSendArInvoiceToFinanceEmailOnly({
            sendArInvoiceToFinanceEmailOnly,
            enterpriseId
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`sendArInvoiceToFinanceEmailOnly Updated!`);
            });
    };

    onToggleArInvoiceFlagSwitch = (e) => {

        const { enterpriseId } = this.props;

        const isActive = e.valueOf();

        /* Switch from Inactive to Active */
        if (isActive) {
            _putActivateConsolidateArInvoiceFlag({
                enterpriseId,
                consolidateArInvoiceFlagToActivate: "consolidateArInvoice",
            })
                .then(res => {
                    this.setState({
                        enterprise: res.data
                    });
                    message.destroy();
                    message.success(`Consolidate Ar Invoice configuration updated!`);
                });
            return;
        }

        /* Switch from Active to Inactive */
        _putDeactivateConsolidateArInvoiceFlags({
            enterpriseId
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Consolidate Ar Invoice configuration updated!`);
            });
    };

    onConsolidateArInvoiceFlagsChange = (e) => {

        const { enterpriseId } = this.props;
        /**
         * `consolidateArInvoice` OR `consolidateArInvoiceBySo`
         * 
         */
        const consolidateArInvoiceFlagToActivate = e.target.value;

        _putActivateConsolidateArInvoiceFlag({
            enterpriseId,
            consolidateArInvoiceFlagToActivate,
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Consolidate Ar Invoice configuration updated!`);
            });
    };

    onConsolidateArInvoiceBySoChange = (consolidateArInvoiceBySo) => {

        const { enterpriseId } = this.props;
        const consolidateArInvoice = Boolean(this.state.enterprise.consolidateArInvoice);

        if (consolidateArInvoiceBySo && consolidateArInvoice) {
            message.destroy();
            message.error("Deselect ERP - Consolidate AR Invoice first!");
            return;
        }

        _putConsolidateArInvoiceBySo({
            enterpriseId,
            consolidateArInvoiceBySo,
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Consolidate Ar Invoice by SO Updated!`);
            });
    };

    onConsolidateArInvoiceChange = (consolidateArInvoice) => {

        const { enterpriseId } = this.props;

        const consolidateArInvoiceBySo = Boolean(this.state.enterprise.consolidateArInvoiceBySo);

        if (consolidateArInvoice && consolidateArInvoiceBySo) {
            message.destroy();
            message.error("Deselect ERP - Consolidate AR Invoice by SO first!");
            return;
        }

        _putConsolidateArInvoice({
            enterpriseId,
            consolidateArInvoice,
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Consolidate Ar Invoice Updated!`);
            });
    };

    onBillingCutOffDatesChange = (val) => {

        const { enterpriseId } = this.props;

        _putBillingCutOffDates({
            enterpriseId,
            billingCutOffDates: val
        })
            .then(res => {
                this.setState({
                    enterprise: res.data
                });
                message.destroy();
                message.success(`Billing Cut Off Dates Updated!`);
            });
    };

    handleOnChangePunchoutTaxConfiguration = (
        punchoutTaxConfiguration
    ) => {

        this.setState({
            enterprise: {
                ...this.state.enterprise,
                punchoutTaxConfiguration
            }
        }, this.postPunchoutChangesToServer);
    };



}

export default connect(
    state => ({
        userData: state.user
    })
)(withRouter(EnterpriseProfile));


// WEBPACK FOOTER //
// ./src/components/enterprise/profile.js